import { Helper } from './utitlity/helper';
import { Component, NgZone, ViewChild, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import * as _ from 'lodash';
import { constants } from './utitlity/constant';
import { LocationStrategy } from '@angular/common';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  template: require('./app.component.html')
})
export class AppComponent implements OnInit{
  ngOnInit(): void {
  }

  leadFooterText: string;

  constructor(private titleService: Title,
              private router: Router) {
    this.router.events.subscribe((val) => {
      if(val instanceof NavigationEnd) {
        this.checkURLPath();
        this.changeURLPath();
      }
    });

		this.checkURLPath();
  }
   
	checkURLPath() {
    let dateyear=new Date().getFullYear();
    this.leadFooterText ='© ' + dateyear +' .'+constants.LEAD_THANKYOU_FOOTER_MSG;
	  
	  let url = window.location.href;

	  if(url.toString().indexOf("iban") != -1) {
      // If IBAN generator tool
      this.setApplicationTitle("IBAN Generator | IBAN Validator");

      constants.IS_LEAD_FORM_APPLICATION = false;
      document.getElementsByTagName("body")[0].style["padding-bottom"] = "0px";
	  } else if(url.toString().indexOf("products") != -1) {
      // If lead forms
      let hashUrlArray = window.location.hash.split('/');
      let productCode = hashUrlArray[hashUrlArray.length-1];
      if(window.location.hash == '#/products/O/D') {
        productCode = 'O/D';
      }

      constants.LEAD_FORM_PRODUCT_CODE = productCode;

      constants.IS_LEAD_FORM_APPLICATION = true;
      document.getElementsByTagName("body")[0].style["padding-bottom"] = "0px";
	  }
  }
  changeURLPath() {
    if(constants.IS_LEAD_FORM_APPLICATION) {
      this.router.navigate(['products', constants.LEAD_FORM_PRODUCT_CODE]);
    }
  }
  setApplicationTitle(newTitle: string) {
    this.titleService.setTitle( newTitle );
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/lodash/lodash.js!./~/tslint-loader!./src/app/app.component.ts